import { render, staticRenderFns } from "./mustericiroveiskonto.vue?vue&type=template&id=72b573b3&scoped=true"
import script from "./mustericiroveiskonto.vue?vue&type=script&lang=js"
export * from "./mustericiroveiskonto.vue?vue&type=script&lang=js"
import style0 from "./mustericiroveiskonto.vue?vue&type=style&index=0&id=72b573b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b573b3",
  null
  
)

export default component.exports